"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./IconButton.css");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var Text_1 = __importDefault(require("../Text"));
function IconButton(_a) {
    var Icon = _a.icon, href = _a.href, _b = _a.target, target = _b === void 0 ? "_blank" : _b, ariaLabel = _a.ariaLabel, onClick = _a.onClick;
    var handleOnClick = function (event) {
        if (!href) {
            event.preventDefault();
        }
        event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (React.createElement("a", { className: "nimbus--icon-button__wrapper", onClick: handleOnClick, href: href, target: href && target, "aria-label": ariaLabel, role: "button" },
        React.createElement("i", { className: "nimbus--icon-button" },
            React.createElement(Tooltip_1.default, { labelIcon: Icon, ariaLabel: ariaLabel },
                React.createElement(Text_1.default, null, ariaLabel)))));
}
var Skeleton = function () { return React.createElement("span", { className: "nimbus--icon-button-skeleton" }); };
IconButton.Skeleton = Skeleton;
exports.default = IconButton;
//# sourceMappingURL=IconButton.js.map